import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Get } from "libs/services";
import { MASTER } from "libs/config";
import { setLoading } from "./loader";
import { MasterResponse } from "src/common/types/response/master";
import { ServerTimeResponse } from "src/common/types/response/serverTime";
import { reportLog } from "src/common/libs/utils/logs";

interface ItemsState {
  data: MasterResponse;
  loading: boolean;
}

export const getMaster = createAsyncThunk(
  "master/getMasterData",
  async ({ headers }: { headers?: any }, thunkAPI) => {
    try {
      const response = await Get<MasterResponse>(MASTER.get, {}, headers || {});
      return response.data;
    } catch (error) {
      reportLog({
        error: error,
        location: "features/master->getMaster[21]",
        body: { headers },
      });
      return null;
    } finally {
    }
  }
);

export const getServerTime = createAsyncThunk(
  "master/getServerTime",
  async (thunkAPI) => {
    try {
      const response = await Get<ServerTimeResponse>(MASTER.serverTime);
      return response.data;
    } catch (error) {
      reportLog({
        error: error,
        location: "features/master->getServerTime",
        body: {},
      });
      return null;
    } finally {
    }
  }
);

const initialState: ItemsState = {
  data: null,
  loading: false,
};

export const itemSlice = createSlice({
  name: "master",
  initialState,
  reducers: {
    clearData: () => initialState,
    saveMaster: (state, action) => {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getMaster.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getMaster.fulfilled, (state, action) => {
      state.data = action.payload;
      state.loading = false;
    });
    builder.addCase(getMaster.rejected, (state, action) => {
      state.data = null;
      state.loading = false;
    });
  },
});

export const { clearData, saveMaster } = itemSlice.actions;

export default itemSlice.reducer;
